import React, {Fragment} from "react";

import SpinnerDiv from "ui/SpinnerDiv";

import {
  defaultTableHeaderStyles,
  defaultPaginationOptions,
  customHeaderStyle, defaultTopLeftCellStyle, defaultTopRightCellStyle,
  TableActionIconEdit, TableActionIconView, TableActionIconDelete
} from "./BaseTableComponents";

import PassportTable, { xlateBootstrapTableColumns} from "root/Tables/PassportTable";

import './Table.scss'
import {ModalAlternateProviderModes} from "root/Modals/ModalAlternateProviders/ModalAlternateProviders";

const TableAltProviders = ({ readOnly, allowDelete, clickHandler, data, isLoading}) =>
{
  const onClickItem = (cap_id, mode) =>
  {
    clickHandler({ cap_id, mode });
  }

  const linkFormatter = (cell, row, rowIndex, formatExtraData) => {
    return (
        <Fragment>
          <TableActionIconView text="View Alternate Provider Details" onClick={() => onClickItem(row.cap_id, ModalAlternateProviderModes.VIEW)}/>
          <TableActionIconEdit text="Edit Alternate Provider Details" onClick={() => onClickItem(row.cap_id, ModalAlternateProviderModes.EDIT)}/>
          {allowDelete !== false &&
          <TableActionIconDelete text="Delete Alternate Provider" onClick={() => onClickItem(row.cap_id, ModalAlternateProviderModes.DELETE)}/>}
        </Fragment>
    );
  }

  const providerFormatter = (cell, row, rowIndex, formatExtraData) =>
  {
    return <div>
      { row.school_name }<br/> <span style={{fontStyle: 'italic', color: 'var(--s360-icon-blue'}}>{ row.ap_reason_text}</span>
    </div>
  }

  const detailFormatter = (cell, row, rowIndex, formatExtraData) =>
  {
    const ovClass =  {whiteSpace: 'normal'} ;

    return <div>
      <span style={ovClass}>{ row.details}</span>
    </div>
  }

  const headerStyle = customHeaderStyle.bind(null, {
    default: defaultTableHeaderStyles,
    school_name: {borderRadius: defaultTopLeftCellStyle, width: "10vw"},
    date_from: {width: "4vw"},
    agreement_date: {width: "3vw"},
    details: {width: "12vw"},
    number_of_hours: {width: "2vw"},
    child_sdq_id: {borderRadius: defaultTopRightCellStyle, textAlign: 'right', width: "6vw"}
  });

  const extra = readOnly ? [] : [
    {
      dataField: "child_sdq_id",
      text: "Action",
      align: 'right',
      formatter: linkFormatter,
      headerStyle: headerStyle
    }
  ] ;

  const getColumns = () => {
    const columns = [
      {
        dataField: "school_name",
        text: "Provider",
        formatter: providerFormatter,
        headerStyle: headerStyle
      },
      {
        dataField: "date_from",
        text: "Date From",
        sort: false,
        headerStyle: headerStyle
      },
      {
        dataField: "agreement_date",
        text: "Agreement Date",
        sort: false,
        headerStyle: headerStyle
      },
      {
        dataField: "details",
        text: "Reason",
        formatter: detailFormatter,
        sort: false,
        headerStyle: headerStyle
      },
      {
        dataField: "number_of_hours",
        text: "Hours",
        sort: false,
        headerStyle: headerStyle
      },
        ...extra
    ];

    return columns;
  };

  const translations = xlateBootstrapTableColumns(getColumns());

  const columns = React.useMemo(() => translations, [readOnly]);

  const tableContent = () =>
  {
    return <PassportTable data={data} columns={columns} pagination={defaultPaginationOptions} showSearch={false}/>
  }

  return isLoading === true ? <SpinnerDiv/> : tableContent();
}

export default TableAltProviders;
